<template>
	<!-- Event Registrations Section (shown when there are any events, including cancelled) -->
	<template v-if="hasEventRegistrations">
		<div class="event-registrations-section">
			<div class="macarfi-section-icon welcom-logo-top">
				<img :src="`${weWelcomUrl}/world/img/wewelcom/logo/logo.png`" alt="WeWelcom" class="wewelcom-logo"/>
			</div>

			<div v-for="registration in eventRegistrations" :key="registration.id">
				<EventPassCard :registration="registration"/>
			</div>

			<div class="container p-0">
				<section class="macarfi-section macarfi-section-intro">
					<div class="macarfi-section-icon">
						<img :src="`${weWelcomUrl}/world/img/wewelcom/logo/logo.png`" alt="WeWelcom" class="wewelcom-logo"/>
					</div>

					<h3 class="macarfi-section-title">Wewelcom es Tecnología más humana para restauración</h3>
					<p>
						<span class="macarfi-section-icon macarfi-number">1</span>
						Profesionales desde el minuto 1 con nuestro director digital
					</p>
					<p>
						<span class="macarfi-section-icon macarfi-number">2</span>
						Por fin podrás vender esas segundas bebidas de forma automática
					</p>
					<p>
						<span class="macarfi-section-icon macarfi-number">3</span>
						Y siempre con el mínimo personal.
					</p>

					<div class="w-100 d-flex justify-content-center align-items-center">
						<a href="http://wewelcom.io" target="_blank" class="btn btn-secondary mx-auto">
							Solicita tu DEMO WeWelcom
						</a>
					</div>
				</section>
			</div>

			<!-- Ver eventos cancelados collapse -->
			<div v-if="cancelledRegistrations.length > 0" class="cancelled-events-collapse">
				<button
					class="btn btn-outline-secondary btn-sm cancelled-events-toggle"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#cancelledEventsCollapse"
					aria-expanded="false"
					aria-controls="cancelledEventsCollapse"
				>
					Ver eventos cancelados ({{ cancelledRegistrations.length }})
				</button>
				<div class="collapse" id="cancelledEventsCollapse">
					<div class="cancelled-events-list">
						<div v-for="registration in cancelledRegistrations" :key="registration.id">
							<EventPassCard :registration="registration"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</template>

	<!-- Restaurant Reservations Section -->
	<template v-if="userReservations.length">
		<div v-for="reservation in userReservations" :key="reservation.id">
			<PassReservationCard :reservation="reservation"/>
		</div>
	</template>

	<!-- No content message -->
	<div v-if="!userReservations.length && !hasEventRegistrations">
		<section class="container">
			<div class="section-header">
				No tienes reservas o invitaciones pendientes.
			</div>
		</section>

		<section class="container" v-if="!isValidateUser">
			<div class="section-header">
				Obtén tu QR único y disfruta de múltiples beneficios:
			</div>
			<div class="section-body">
				<ul>
					<li>Haz reservas fácilmente desde tu móvil.</li>
					<li>Accede a la carta digital y realiza pedidos al instante.</li>
					<li>Explora y disfruta de tus restaurantes favoritos.</li>
					<li>Crea momentos inolvidables con tus seres queridos.</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import {storeToRefs} from 'pinia';
import {useUserEventRegistrationsStore} from '@/store/userEventRegistrationsStore';
import PassReservationCard from "@/components/passReservationCard/PassReservationCard";
import EventPassCard from "@/components/eventPassCard/EventPassCard";

export default {
	data() {
		return {
			contentReservationText: '',
			isValidateUser: false,
		};
	},
	components: {
		PassReservationCard,
		EventPassCard,
	},
	setup() {
		const eventRegistrationsStore = useUserEventRegistrationsStore();
		const {
			upcomingRegistrations: eventRegistrations,
			cancelledRegistrations,
			isLoading: eventRegistrationsLoading,
		} = storeToRefs(eventRegistrationsStore);

		return {
			eventRegistrationsStore,
			eventRegistrations,
			cancelledRegistrations,
			eventRegistrationsLoading,
		};
	},
	beforeMount() {
		console.log('el usuario antes de montar el container', this.user)
		this.isValidateUser = this.user.type === 2
	},
	async mounted() {
		console.log('Todas las reservas desde el contenedor', this.userReservations)

		// Load event registrations
		if (this.user?.hostCode) {
			await this.eventRegistrationsStore.loadRegistrations(this.user.hostCode);
			console.log('Event registrations loaded:', this.eventRegistrations);
		}
	},
	computed: {
		...mapGetters('user', ['user', 'reserveUrl', 'userReservations', 'latestVenueConfig']),
		...mapGetters('wePass', ['actionParam', 'reservationIdParam']),
		...mapGetters('config', ['websocketUrl', 'websocketPort', 'weWelcomUrl']),
		hasEventRegistrations() {
			return this.eventRegistrations.length > 0 || this.cancelledRegistrations.length > 0;
		},
	},
	methods: {}
};
</script>

<style scoped lang="scss">
.event-registrations-section {
	margin-bottom: 1rem;
	touch-action: pan-x pan-y;
	overscroll-behavior-y: auto;
}

.welcom-logo-top {
	display: flex;
	width: fit-content;
	max-width: calc(100% - 2rem);
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 1rem;
	padding: 0.75rem 1.5rem;
	touch-action: pan-x pan-y;
	overscroll-behavior-y: auto;

	img.wewelcom-logo {
		max-height: 40px;
		display: block;
	}
}

.macarfi-section {
	background: rgba(255, 255, 255);
	border-radius: 16px;
	padding: 1.5rem;
	margin-bottom: 1rem;
	position: relative;
	overflow: hidden;
	color: black;
	touch-action: pan-x pan-y;
	overscroll-behavior-y: auto;
}

.macarfi-section::before,
.macarfi-number::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 3px;
	background: var(--app-accent);
}

.macarfi-section-icon {
	//width: 50px;
	//height: 50px;
	background: rgba(var(--app-primary-rgb), 100%);
	border: 1px solid rgba(var(--app-primary-rgb), 0.3);
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1rem;
	color: var(--app-accent);
	touch-action: pan-x pan-y;
	overscroll-behavior-y: auto;

	img {
		max-height: 80px;
		min-width: 0;
	}
}

.macarfi-section-icon i {
	font-size: 1.25rem;
}

.macarfi-section-title {
	font-size: 1.25rem;
	font-weight: 700;
	color: #000;
	margin-bottom: 1rem;
}

.macarfi-section p {
	color: rgba(0, 0, 0, 0.8);
	font-size: 1.15rem;
	margin-bottom: 1rem;
	line-height: 1.7;
	display: flex;
	gap: 1rem;
	align-items: center;
}

.macarfi-section p:last-child {
	margin-bottom: 0;
}

.macarfi-section strong {
	color: var(--app-primary);
}

.macarfi-section em {
	color: rgba(var(--app-primary-rgb), 0.95);
}

.macarfi-number {
	width: 40px;
	height: 40px;
	color: var(--app-accent);
	flex-shrink: 0;
	font-weight: 600;
	font-size: 1.5rem;
	position: relative;
	overflow: hidden;
}

.cancelled-events-collapse {
	margin-top: 1rem;
}

.cancelled-events-toggle {
	width: 100%;
}

.cancelled-events-list {
	margin-top: 0.75rem;
}
</style>
